import {
  buildRecommendations,
  Recommendations
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
} from "@coveo/headless/commerce";
import { getCommerceEngine } from "@DSG/Coveo/Contex/Engine";
import { CoveoHandler, CoveoStrictInputDispatch } from "@DSG/Store/CoveoHandlerCreator/CoveoHandlerCreator";
import { CoveoCommerceState } from "@DSG/Store/Data/CoveoCommerceState";
import { DISPATCH_RECOMMENDATIONS_LIST_STATE } from "@DSG/Store/Reducer/CoveoCommerceReducer";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

export interface Parameter {
    slotId: string;
    coveoCommerce: CoveoCommerceState;
    productNumber:string | undefined;
}

export type HandleType = Handler<Parameter, CoveoHandler>;

export const recommendationControllers: Record<string, Recommendations> = {};

const getRecommendationController = async (
  slotId: string,
  productNumber?: string
): Promise<Recommendations> => {
  if (recommendationControllers[slotId]) {
    return recommendationControllers[slotId];
  }

  const engine = await getCommerceEngine();

  const recommendation = buildRecommendations(engine, {
    options: {
      slotId,
      ...(productNumber && { productId: productNumber }),
    },
  });

  recommendationControllers[slotId] = recommendation;

  return recommendation;
};

const subscribeToRecommendation = (
    slotId: string,
    recommendation: Recommendations,
    dispatch: CoveoStrictInputDispatch
) => {
    recommendation.subscribe(() => {
      const state = recommendation.state;
  
      if (!state.isLoading) {
        dispatch({
          type: DISPATCH_RECOMMENDATIONS_LIST_STATE,
          state: {
            recommendationState: state,
            slotId,
          },
        });
      }
    });
};

const getRecommendationConfigurations = async (
    slotId: string,
    coveoCommerce: CoveoCommerceState, 
    productNumber: string | undefined,
    dispatch: CoveoStrictInputDispatch
) => {
    const recommendation = await getRecommendationController(slotId, productNumber);

    subscribeToRecommendation(slotId, recommendation, dispatch);
    recommendation.refresh();
}

export const CoveoRecommendation: HandleType = (props) => {
    const { dispatch, parameter } = props;
    const { slotId, coveoCommerce,productNumber } = parameter;

    if (!slotId || !coveoCommerce) { return; }
    
    getRecommendationConfigurations(slotId, coveoCommerce,productNumber, dispatch as CoveoStrictInputDispatch);
};

export const chain = [CoveoRecommendation];

const coveoRecommendation = createHandlerChainRunner(chain, "coveoRecommendation");

export default coveoRecommendation;
